import React from 'react';
import 'utilities/global.css';
import ReactDOM from 'react-dom';

function includeMe(Component) {
  let wrapper = document.createElement('div');
  const config = JSON.parse('{{{bikConfig}}}');
  wrapper.id = `bik-widget-wrapper-${config.id}`;
  wrapper.className = 'bik-widget__outer-wrapper';
  document.body.appendChild(wrapper);
  const widget = document.getElementById(`bik-widget-wrapper-${config.id}`);
  ReactDOM.render(<Component {...config} />, widget);
}

export default includeMe;
